<template>
  <v-dialog :value="value" @input="$emit('input', $event)" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ isEditing ? 'Fahrzeug bearbeiten' : 'Neues Fahrzeug' }}</span>
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="name" label="Fahrzeugname" required outlined @keydown.enter="onSave"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Abbrechen</v-btn>
        <v-btn color="primary" text @click="onSave">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "VehicleDialog",
  props: {
    value: { type: Boolean, required: true },
    isEditing: { type: Boolean, default: false },
    vehicleName: { type: String, default: '' }
  },
  data() {
    return {
      name: ''
    };
  },
  watch: {
    // When the dialog is opened, sync the initial name
    value: {
      handler(isOpen) {
        if (isOpen) {
          this.name = this.vehicleName || '';
        }
      },
      immediate: true
    }
  },
  methods: {
    onSave() {
      this.$emit('save', this.name);
      this.$emit('input', false);
    }
  }
}
</script>